/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import * as React from 'react';
import './CurveCard.scss';
import { Size, Paper, FlexItem, Icon } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';

const CurveCard = ({...props}) => {

  const CardClicked = (id: any) => {
    props.onChemicalChanged(id);
  }

  return (
    <FlexItem className="chemical-card" data-id={props.cardData.Id} onClick={() => CardClicked(props.cardData.Id)}>
        <Paper>
            <div className="cta-icon-wrapper">
                <Icon className="cta-icon" name={VaiIcon.ChevronRight} size={Size.L}/>
            </div>
            <p className="chemical-name">{props.cardData.Name}</p>
            <p className="chemical-info">{props.cardData.Confidential === "1" && <span className="confidential-circle"></span> } {props.cardData.ConcMin}-{props.cardData.ConcMax}% {props.cardData.Unit}</p>
        </Paper>
    </FlexItem>
  );
};
export default CurveCard;
